/* eslint-disable import/prefer-default-export */
import { variant1, variant2 } from './constants';
/**
 * Stores a variety of props which change value depending on what site the user is on
 *
 * @param {variant} string - String containing the variant name
 *  @returns {object} - Returns an object containing the prop values based on the variant
 */
export var useConfiguration = function (variant) {
    var useThreeSixtyAltIcon;
    var immediatelyLoadImages = false;
    var threeSixtyImageHeight;
    switch (variant) {
        // Common use case
        case variant1:
            break;
        // BAP pages
        case variant2:
            useThreeSixtyAltIcon = true;
            immediatelyLoadImages = true;
            threeSixtyImageHeight = ['234px', '263px', '380px'];
            break;
        default:
            break;
    }
    return { useThreeSixtyAltIcon: useThreeSixtyAltIcon, immediatelyLoadImages: immediatelyLoadImages, threeSixtyImageHeight: threeSixtyImageHeight };
};
